import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const CACHE = "pc-cache:";
const QUEUE = "pc-queue";

export const errMsg = (e) => e?.response?.data?.detail || (e?.response ? "Request failed" : "No connection");
export const imgSrc = (ref) => (ref && !ref.startsWith("data:") ? `${API}/files/${ref}` : ref);

export async function cachedGet(url, params) {
  const key = CACHE + url + JSON.stringify(params || {});
  try {
    const r = await api.get(url, { params });
    try { localStorage.setItem(key, JSON.stringify(r.data)); } catch { /* storage full */ }
    return { data: r.data, offline: false };
  } catch (e) {
    const cached = !e.response && localStorage.getItem(key);
    if (cached) return { data: JSON.parse(cached), offline: true };
    throw e;
  }
}

export const setCache = (url, data) => {
  try { localStorage.setItem(CACHE + url + "{}", JSON.stringify(data)); } catch { /* storage full */ }
};

export const queue = {
  list: () => JSON.parse(localStorage.getItem(QUEUE) || "[]"),
  save: (items) => { localStorage.setItem(QUEUE, JSON.stringify(items)); window.dispatchEvent(new Event("pc-queue")); },
  add(item) { this.save([...this.list().filter((i) => i.id !== item.id), item]); },
  remove(id) { this.save(this.list().filter((i) => i.id !== id)); },
};

export async function flushQueue() {
  const results = { synced: 0, failed: [] };
  for (const item of queue.list()) {
    try {
      await api.request({ method: item.method || "put", url: item.url, data: item.body });
      queue.remove(item.id);
      results.synced += 1;
    } catch (e) {
      if (!e.response) break;
      queue.remove(item.id);
      results.failed.push(`${item.label}: ${errMsg(e)}`);
    }
  }
  return results;
}

export async function download(url, filename) {
  const r = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}

export function compressImage(file, max = 1280) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, max / Math.max(img.width, img.height));
      const c = document.createElement("canvas");
      c.width = img.width * scale;
      c.height = img.height * scale;
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      resolve(c.toDataURL("image/jpeg", 0.7));
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}
